export default __webpack_public_path__ + "static/media/Group 4782.2b9406c7.svg";